import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import AddSurveyItem from './AddSurveyItem';

const i18nMessages = defineMessages({
  surveyItemCode: {
    id: 'menu.item-bank-management.survey-item-code',
    defaultMessage: 'Survey Item Code',
  },
  surveyItemText: {
    id: 'menu.item-bank-management.survey-item-text',
    defaultMessage: 'Survey Item Text',
  },
  surveyItemSelfText: {
    id: 'menu.item-bank-management.survey-item-self-text',
    defaultMessage: 'Survey Item Self Text',
  },
  actions: {
    id: 'menu.item-bank-management.actions',
    defaultMessage: 'Actions',
  },
});

const AddSurveyItems = ({ onSave }) => {
  const { formatMessage } = useIntl();

  const history = useHistory();

  const [index, setIndex] = useState(null);

  const { values: parentFormValues, setFieldValue } = useFormikContext();

  const itemValues = parentFormValues.surveyItems;

  const initialValues =
    index != null
      ? {
          code: itemValues[index].code,
          text: itemValues[index].text,
          selfText: itemValues[index].selfText,
        }
      : {
          code: '',
          text: '',
          selfText: '',
        };

  const validationSchema = Yup.object().shape({
    code: Yup.string().required(),
    text: Yup.string().required(),
    selfText: Yup.string().required(),
  });

  const actionsBody = (data, { rowIndex }) => (
    <div className="align-center">
      <Button type="button" className="p-button-secondary" icon="pi pi-pencil" onClick={() => setIndex(rowIndex)} />
    </div>
  );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => {
          formikBag.resetForm();

          if (index != null) {
            const updatedValues = itemValues.map((surveyItem, surveyItemIndex) => {
              if (surveyItemIndex === index) {
                return { ...values };
              }

              return surveyItem;
            });

            setFieldValue('surveyItems', updatedValues);
            setIndex(null);
          } else {
            setFieldValue('surveyItems', [...parentFormValues.surveyItems, { ...values }]);
          }
        }}
      >
        <Form>
          <AddSurveyItem />
          <FormattedMessage
            id="item-bank-management.context-type.save-survey-item-text"
            defaultMessage="Save Survey Item Text"
          >
            {(text) => <Button type="submit" className="p-button-secondary inner-form-submit-button" label={text} />}
          </FormattedMessage>
        </Form>
      </Formik>
      <DataTable value={itemValues} className="text-center">
        <Column field="code" header={formatMessage(i18nMessages.surveyItemCode)} />
        <Column field="text" header={formatMessage(i18nMessages.surveyItemText)} />
        <Column field="selfText" header={formatMessage(i18nMessages.surveyItemSelfText)} />
        <Column body={actionsBody} header={formatMessage(i18nMessages.actions)} />
      </DataTable>
      <div className="outer-form-submit-button">
        <FormattedMessage id="actions.save" defaultMessage="Save">
          {(text) => <Button type="button" label={text} onClick={onSave} />}
        </FormattedMessage>
        <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
          {(text) => (
            <Button type="button" onClick={() => history.goBack()} className="p-button-secondary" label={text} />
          )}
        </FormattedMessage>
      </div>
    </>
  );
};

AddSurveyItems.propTypes = {
  onSave: PropTypes.func.isRequired,
};

export default AddSurveyItems;
